import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Scroll from 'react-scroll';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useRecoilState } from 'recoil';
import { faVideo, faTachometer, faEye, faPencil, faTrashCan, faPlus, faTable, faArrowRight, faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';

import { getCMSVideoListAPI, deleteCMSVideoAPI } from "../../API/CMSVideo";
import FormErrorBox from "../Reusable/FormErrorBox";
import PageLoadingContent from "../Reusable/PageLoadingContent";
import { topAlertMessageState, topAlertStatusState } from "../../AppState";
import { getVideoStateLabelByValue } from "../../Constants/FieldOptions";


function PickCMSVideoModal({ modalTitle, isVisible, setIsVisible, onClick }) {

    ////
    //// Component states.
    ////

    const [errors, setErrors] = useState({});
    const [videos, setVideos] = useState("");
    const [isFetching, setFetching] = useState(false);

    ////
    //// API.
    ////

    function onVideoListSuccess(response){
        console.log("onVideoListSuccess: Starting...");
        setVideos(response);
    }

    function onVideoListError(apiErr) {
        console.log("onVideoListError: Starting...");
        setErrors(apiErr);

        // The following code will cause the screen to scroll to the top of
        // the page. Please see ``react-scroll`` for more information:
        // https://github.com/fisshy/react-scroll
        var scroll = Scroll.animateScroll;
        scroll.scrollToTop();
    }

    function onVideoListDone() {
        console.log("onVideoListDone: Starting...");
        setFetching(false);
    }

    ////
    //// Event handling.
    ////

    const fetchList = () => {
        setFetching(true);
        getCMSVideoListAPI(
            onVideoListSuccess,
            onVideoListError,
            onVideoListDone
        );
    }

    ////
    //// Misc.
    ////

    useEffect(() => {
        let mounted = true;

        if (mounted) {
            window.scrollTo(0, 0);  // Start the page at the top of the page.
            fetchList();
        }

        return () => { mounted = false; }
    }, []);

    ////
    //// Component rendering.
    ////

    // Render the JSX content.
    return (
        <>
            {isVisible && <>
                <div class="modal is-active">
                    <div class="modal-background"></div>
                    <div class="modal-card">
                        <header class="modal-card-head">
                            <p class="modal-card-title">{modalTitle}</p>
                            <button class="delete" aria-label="close" onClick={(e)=>setIsVisible(false)}></button>
                        </header>
                        <section class="modal-card-body">
                            <FormErrorBox errors={errors} />

                            {isFetching
                                ? <>
                                    <PageLoadingContent displayMessage={"Please wait"} /> </>
                                : <>
                                    {videos && videos.length > 0
                                        ?
                                        <div class="container">
                                            <div class="b-table">
                                                <div class="table-wrapper has-mobile-cards">
                                                    <table class="table is-fullwidth is-striped is-hoverable is-fullwidth">
                                                        <thead>
                                                            <tr>
                                                                <th>Name</th>
                                                                <th>State</th>
                                                                <th></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {videos && videos.map(function(video, i){
                                                                return <tr>
                                                                    <td data-label="Name">
                                                                        <Link to={`/cms-video/${video.id}`} target="_blank" rel="noreferrer">
                                                                            {video.name}&nbsp;<FontAwesomeIcon className="fas" icon={faArrowUpRightFromSquare} />
                                                                        </Link>
                                                                    </td>
                                                                    <td data-label="State">{getVideoStateLabelByValue(video.state)}</td>
                                                                    <td class="is-actions-cell">
                                                                        <div class="buttons is-right">
                                                                            <button onClick={(e,v)=>onClick(video)} class="button is-small is-primary" type="button">
                                                                                Pick&nbsp;<FontAwesomeIcon className="mdi" icon={faArrowRight} />
                                                                            </button>
                                                                        </div>
                                                                    </td>
                                                                </tr>;
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        <section class="hero is-medium has-background-white-ter">
                                          <div class="hero-body">
                                            <p class="title">
                                                <FontAwesomeIcon className="fas" icon={faTable} />&nbsp;No Videos
                                            </p>
                                            <p class="subtitle">
                                                No videos. <b><Link to="/cms-videos/add">Click here&nbsp;<FontAwesomeIcon className="mdi" icon={faArrowRight} /></Link></b> to get started uploading your first video.
                                            </p>
                                          </div>
                                        </section>
                                    }
                                </>
                            }
                        </section>
                        <footer class="modal-card-foot">
                            {/* <button class="button is-success" onClick={(e)=>setIsVisible(false)}>Save changes</button> */}
                            <button class="button" onClick={(e)=>setIsVisible(false)}>Cancel</button>
                        </footer>
                    </div>
                </div>
            </>}
        </>
    )
}

export default PickCMSVideoModal;
